import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="footer-page-container4">
      <h1>Terms and Conditions</h1>
      
      <div className="footer-page-content4">
        <section className="terms-section">
          
          <div className="terms-notice">
            <p><strong>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY.</strong> BY ACCESSING OR USING OUR WEBSITE, YOU AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS AND ALL APPLICABLE LAWS AND REGULATIONS. IF YOU DO NOT AGREE WITH ANY OF THESE TERMS, YOU ARE PROHIBITED FROM USING OR ACCESSING THIS SITE.</p>
          </div>
          
          <h2>1. Age Restriction</h2>
          <p>
            The products offered on this website are exclusively intended for adults 21 years of age or older. By accessing our website and/or purchasing our products, you confirm and represent that you are at least 21 years of age.
          </p>
          <p>
            We implement age verification procedures to comply with applicable laws and regulations. We reserve the right to refuse service, terminate accounts, or cancel orders if we suspect the customer is under 21 years of age.
          </p>
          
          <h2>2. Account Registration</h2>
          <p>
            To access certain features of our website or to make purchases, you may be required to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
          </p>
          <p>
            You are responsible for safeguarding your account password and for any activities or actions under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
          </p>
          <p>
            We reserve the right to disable any user account at any time in our sole discretion for any reason, including if we believe that you have violated or acted inconsistently with these Terms and Conditions.
          </p>
          
          <h2>3. Product Purchases</h2>
          <p>
            All product descriptions, including pricing and availability, are subject to change at any time without notice. We reserve the right to modify or discontinue any product at any time.
          </p>
          <p>
            All prices are displayed in Indian Ruppees and do not include taxes and shipping costs, which will be added at checkout. We reserve the right to refuse or cancel any orders placed for products listed at an incorrect price due to typographical errors or errors in pricing information.
          </p>
          <p>
            Your receipt of an electronic or other form of order confirmation does not signify our acceptance of your order. We reserve the right to limit or prohibit orders that appear to be placed by dealers, resellers, or distributors.
          </p>
          
          <h2>4. Shipping and Delivery</h2>
          <p>
            Shipping times and delivery dates are estimates only and cannot be guaranteed. We are not liable for any delays in shipments.
          </p>
          <p>
            All deliveries require an adult signature (21+ years) at the time of delivery. This is a legal requirement for tobacco products and cannot be waived. If no eligible recipient is available to sign for the package, the carrier will leave a notice and attempt delivery again on the next business day.
          </p>
          <p>
            For more information, please refer to our <a href="/shipping-policy">Shipping Policy</a>.
          </p>
          
          <h2>5. Returns and Refunds</h2>
          <p>
            Due to the nature of our products, we have a limited return policy. Returns are only accepted for damaged, defective, or incorrectly shipped items. All returns must be initiated within 7 days of receipt.
          </p>
          <p>
            Used or opened products cannot be returned unless they are defective. Return shipping costs are the responsibility of the customer unless the return is due to our error.
          </p>
          <p>
            For more information, please refer to our <a href="/return-policy">Return Policy</a>.
          </p>
          
          <h2>6. Intellectual Property Rights</h2>
          <p>
            The content on our website, including but not limited to text, graphics, logos, images, audio clips, digital downloads, data compilations, and software, is our property or the property of our content suppliers and is protected by India and international copyright laws.
          </p>
          
          <h2>7. User Conduct</h2>
          <p>
            You agree not to use our website for any unlawful purpose or any purpose prohibited by these Terms and Conditions. You agree not to:
          </p>
          <ul>
            <li>Use our website in any manner that could disable, overburden, damage, or impair the site</li>
            <li>Use any robot, spider, or other automatic device, process, or means to access our website for any purpose</li>
            <li>Introduce any viruses, Trojan horses, worms, logic bombs, or other harmful material</li>
            <li>Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of our website</li>
            <li>Harass, threaten, intimidate, or impersonate any other users or Tobacco Store staff</li>
          </ul>
          
          <h2>8. Disclaimer of Warranties</h2>
          <p>
            OUR WEBSITE AND ALL PRODUCTS OFFERED ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>
          <p>
            WE DO NOT WARRANT THAT THE FUNCTIONS CONTAINED IN THE WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THIS SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
          </p>
          
          <h2>9. Limitation of Liability</h2>
          <p>
            IN NO EVENT SHALL WE BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE, (III) UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY PERSONAL INFORMATION STORED THEREIN, (IV) INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR WEBSITE, (V) BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE, OR (VI) ANY LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE.
          </p>
          
          <h2>10. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Tobacco Store, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms and Conditions or your use of the website.
          </p>
          
          <h2>11. Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of Bihar, without giving effect to any principles of conflicts of law. Any dispute arising under or relating in any way to these Terms and Conditions shall be resolved exclusively by final and binding arbitration in Buxar, Bihar, except that you may bring a claim in a small claims court having jurisdiction over the dispute.
          </p>
          
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms and Conditions at any time. The most current version will be posted on our website with the effective date. By continuing to access or use our website after any revisions become effective, you agree to be bound by the revised terms.
          </p>
          
          <h2>13. Contact Information</h2>
          <p>
            Questions about the Terms and Conditions should be sent to us at:
          </p>
          <address>
          In Front of Mahila Thana<br />
          Gola Bazar, Buxar<br />
          Bihar, PIN 802101<br />
          Email: keshritobacco.store@gmail.com<br />
          Phone: (+91) 9955059485
          </address>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions; 